// extracted by mini-css-extract-plugin
module.exports = {"stepOneContainer":"style_stepOneContainer__2MRSu","tipsImg":"style_tipsImg__3MIh2","tips":"style_tips__2iGJH","btns":"style_btns__cHdYm","cancelAction":"style_cancelAction__Kgfgi"};